export interface RoutesInfo {
  path: string
  title?: string
}

export const EMPTY = ''
